import { createFileRoute } from "@tanstack/react-router";
import { Mail } from "@/components/Mails";

function RouteComponent() {
  return <Mail />;
}

export const Route = createFileRoute("/_authenticated/mail/")({
  component: RouteComponent,
  staticData: { page: ["mail", "entities"] },
});
